import { createSlice } from "@reduxjs/toolkit";
import { logInSuccess, signOutSuccess } from "src/modules/auth/duck/actions";

const initialState = {
  byId: {}
};

const commandSlice = createSlice({
  initialState,
  name: "command",
  reducers: {
    saveCommand(state, { payload }) {
      state.byId[payload.objectId] = payload;
    },
    deleteCommand(state, { payload }) {
      delete state.byId[payload];
    },
    replaceCommands(state, { payload }) {
      state.byId = payload;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(logInSuccess, () => {
        return initialState;
      })
      .addCase(signOutSuccess, () => {
        return initialState;
      });
  }
});

export { commandSlice };
export default commandSlice.reducer;
